import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/** Display preferences. Portable store; only persistence is platform-bound (see store/location). */
export type ClockFormat = '12h' | '24h'

interface PrefsState {
  clock: ClockFormat
  setClock: (clock: ClockFormat) => void
  toggleClock: () => void
}

export const usePrefs = create<PrefsState>()(
  persist(
    (set, get) => ({
      clock: '12h',
      setClock: (clock) => set({ clock }),
      toggleClock: () => set({ clock: get().clock === '12h' ? '24h' : '12h' }),
    }),
    { name: 'taw.prefs' },
  ),
)
